
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TimezoneSelectorProps {
  timezone: string;
  setTimezone: (timezone: string) => void;
}

export default function TimezoneSelector({ timezone, setTimezone }: TimezoneSelectorProps) {
  // Australian timezones with clearer current offset labels
  const australianTimezones = [
    { value: "Australia/Sydney", label: "(GMT+10:00) Sydney, Canberra, Newcastle (AEST/AEDT)" },
    { value: "Australia/Melbourne", label: "(GMT+10:00) Melbourne, Geelong, Victoria (AEST/AEDT)" },
    { value: "Australia/Brisbane", label: "(GMT+10:00) Brisbane, Gold Coast, Queensland (AEST)" },
    { value: "Australia/Adelaide", label: "(GMT+9:30) Adelaide, South Australia (ACST/ACDT)" },
    { value: "Australia/Perth", label: "(GMT+8:00) Perth, Western Australia (AWST)" },
    { value: "Australia/Darwin", label: "(GMT+9:30) Darwin, Northern Territory (ACST)" },
    { value: "Australia/Hobart", label: "(GMT+10:00) Hobart, Tasmania (AEST/AEDT)" }
  ];

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-medium text-center">Your Timezone</h3>
      <p className="text-center text-gray-600 text-sm mb-2">
        This affects when you'll receive your quotes
      </p>
      <Select value={timezone || australianTimezones[0].value} onValueChange={setTimezone}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select your timezone" />
        </SelectTrigger>
        <SelectContent>
          {australianTimezones.map(tz => (
            <SelectItem key={tz.value} value={tz.value}>
              {tz.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
